/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class HfJobsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Job Callback
     * @param jobId
     * @param data
     * @returns any Successful Response
     * @throws ApiError
     */
    public jobCallbackHfJobsCallbackJobIdPost(
        jobId: string,
        data: any,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/hf-jobs/callback/{job_id}',
            path: {
                'job_id': jobId,
            },
            query: {
                'data': data,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
